import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './edm-network-driller/HeroSection';
import { BreadcrumbSection } from './edm-network-driller/BreadcrumbSection';
import { DescriptionSection } from './edm-network-driller/DescriptionSection';
import { EDMMaxZNCSection } from './edm-network-driller/EDMMaxZNCSection';
import { ChmerZNCSection } from './edm-network-driller/ChmerZNCSection';
import { ChmerCNCSection } from './edm-network-driller/ChmerCNCSection';
export function EDMNetworkDrillerPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2120">
      <SeoBar data-id="element-2121" />
      <Header data-id="element-2122" />
      <main className="flex-grow" data-id="element-2123">
        <div className="w-full bg-gray-50 pb-20 min-h-screen" data-id="element-2124">
          <HeroSection data-id="element-2125" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2126">
            <BreadcrumbSection data-id="element-2127" />
            <DescriptionSection data-id="element-2128" />
            <div className="space-y-16" data-id="element-2129">
              <EDMMaxZNCSection data-id="element-2130" />
              <ChmerZNCSection data-id="element-2131" />
              <ChmerCNCSection data-id="element-2132" />
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-2133" />
    </div>;
}